<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>考务管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/examination_Management/individual_examination_management/examination_home_manage/examination_home_manage' }">个人赛考务管理</el-breadcrumb-item>
      <el-breadcrumb-item>全国总决选</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- tabs -->
    <el-tabs type="border-card" v-model="activeName" @tab-click="searchFn">
      <el-tab-pane label="小组赛" name="first"></el-tab-pane>
      <el-tab-pane label="无组别挑战赛" name="second"></el-tab-pane>
    </el-tabs>
    <!-- 筛选 -->
    <div class="tab-search-card">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="100px"
        ref="queryFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择赛季"
                style="width: 100%"
                v-model="queryForm.season"
                @change="searchFn"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="组别" prop="level" v-if="activeName === 'first'">
              <el-select
                placeholder="请选择组别"
                style="width: 100%"
                v-model="queryForm.level"
              >
                <el-option
                  v-for="item in dict_group"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="queryForm.userName"
                placeholder="请输入姓名"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="queryForm.season === '2024~2025' &&  activeName === 'first' && activeRoundName !== '3'">
            <el-col :span="24">
                <el-checkbox
                    v-model="scoreValid"
                    @change="refreshDataList"
                    >只查询成绩有效的数据(按分数降序排序)</el-checkbox
                >
            </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="searchFn">查询</el-button>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </div>
    <el-card style="margin-top: 15px" v-if="queryForm.season === '2024~2025' &&  activeName === 'first'">
      <el-tabs v-model="activeRoundName" @tab-click="refreshDataList">
        <el-tab-pane label="积分赛Round A" name="1"></el-tab-pane>
        <el-tab-pane label="积分赛Round B" name="2"></el-tab-pane>
        <el-tab-pane label="冠军赛Round C" name="3"></el-tab-pane>
        <el-tab-pane label="复活赛" name="4"></el-tab-pane>
      </el-tabs>
      <div>
        <el-row>
          <el-col :span="12">
            <div class="tips" v-if="activeRoundName === '1'">按照本轮分数排序</div>
            <div class="tips" v-if="activeRoundName === '2'">按照1+2轮分数排序，再按照本轮答题时长排序</div>
            <div class="tips" v-if="activeRoundName === '3'">单轮淘汰名次</div>
            <div class="tips" v-if="activeRoundName === '4'">按照本轮分数排序，再按照本轮答题时长排序</div>
          </el-col>
          <el-col :span="12" align="right">
            <el-button type="warning" plain @click="handleToReferee">前往裁判系统</el-button>
            <el-button v-if="activeRoundName === '1' || activeRoundName === '2'" type="primary" plain @click="visible = true">批量设置晋级</el-button>
            <el-button v-if="activeRoundName === '1' || activeRoundName === '2'" type="primary" plain @click="exportFn">导出数据</el-button>
          </el-col>
        </el-row>
        <el-table
            header-cell-class-name="tableHeaderStyle"
            :data="dataFinalList"
            border
            stripe
        >
            <el-table-column
                label="序号"
                type="index"
                width="50px"
            ></el-table-column>
            <el-table-column label="姓名" prop="userName"></el-table-column>
            <el-table-column label="国赛号码牌" prop="matchNum">
              <template slot-scope="scope">
                <span class="num" v-if="activeRoundName === '1' || activeRoundName === '4'">{{ addZero(scope.row.matchNum) }}</span>
                <span class="num" v-else>{{ addZero(scope.row.tbEnrollmentRoundInfos[0].number) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="手机号" prop="phone"></el-table-column>
            <el-table-column
                label="组别"
                prop="level"
                :formatter="levelFormat"
            ></el-table-column>
            <!-- <el-table-column
                label="年级"
                prop="examinationUserGrade"
                :formatter="gradeFormat"
            ></el-table-column> -->
            <el-table-column label="学校" prop="schoolName"></el-table-column>
            <el-table-column v-if="activeRoundName === '1'" label="本轮分数" prop="roundOne"></el-table-column>
            <el-table-column v-if="activeRoundName === '2'" label="本轮分数" prop="roundTwo"></el-table-column>
            <el-table-column v-if="activeRoundName === '2'" label="1+2轮分数" prop="roundTotal"></el-table-column>
            <el-table-column v-if="activeRoundName === '4'" label="本轮分数" prop="score"></el-table-column>
            <el-table-column v-if="activeRoundName === '2'" label="答题时长/秒" prop="totalTimes"></el-table-column>
            <el-table-column v-if="activeRoundName === '1' || activeRoundName === '4'" label="答题时长/秒" prop="times"></el-table-column>
            <el-table-column v-if="activeRoundName === '4'"
                label="晋级无组别"
                width="120px"
                fixed="right"
            >
                <template slot-scope="scope">
                    <el-tag
                        type="danger"
                        v-if="scope.row.promotion === 2"
                        size="mini"
                        >未晋级</el-tag
                    >
                    <el-tag
                        type="success"
                        v-else-if="
                            scope.row.promotion === 1
                        "
                        size="mini"
                        >晋级</el-tag
                    >
                    <el-tag
                        type="warning"
                        v-else-if="
                            !scope.row.promotion ||
                            scope.row.promotion === 0
                        "
                        size="mini"
                        >未设置</el-tag
                    >
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column v-else
                label="本轮晋级状态"
                width="120px"
                fixed="right"
            >
                <template slot-scope="scope">
                    <el-tag
                        type="danger"
                        v-if="getCurrentRoundPromotion(scope.row) === 2"
                        size="mini"
                        >未晋级</el-tag
                    >
                    <el-tag
                        type="success"
                        v-else-if="
                            getCurrentRoundPromotion(scope.row) === 1
                        "
                        size="mini"
                        >晋级</el-tag
                    >
                    <el-tag
                        type="warning"
                        v-else-if="
                            !getCurrentRoundPromotion(scope.row) ||
                            getCurrentRoundPromotion(scope.row) === 0
                        "
                        size="mini"
                        >未设置</el-tag
                    >
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="200px">
              <template slot-scope="scope">
                <el-button v-if="activeRoundName === '4'"
                    type="text"
                    size="small"
                    @click="scoreRoundEditDialog2(scope.row)"
                    >设置晋级无组别</el-button>
                <el-button v-else
                    type="text"
                    size="small"
                    @click="scoreRoundEditDialog(scope.row)"
                    >设置晋级</el-button>
                <el-button
                  type="text"
                  size="small"
                  style="margin-right: 12px"
                  v-if="activeRoundName !== '3'"
                  @click="turnAnswerResult(scope.row)"
                  >答题详情</el-button>
              </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="pageIndex2"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="pageSize2"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total2"
        >
        </el-pagination>
      </div>
    </el-card>
    <el-card style="margin-top: 15px" v-else-if="queryForm.season === '2024~2025' &&  activeName === 'second'">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">选手列表</span>
        </el-col>
        <el-col :span="15" style="text-align: right;">
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataListFinalMixedGroup"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="姓名" prop="userName"></el-table-column>
        <el-table-column label="比赛号码牌" prop="matchNum">
          <template slot-scope="scope">
            <span class="num">{{ addZero(scope.row.matchNum) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column label="学校" prop="schoolName"></el-table-column>
        <el-table-column label="年级" prop="grade" :formatter="gradeFormatter"></el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 列表（第一季、第二季） -->
    <el-card style="margin-top: 15px" v-else>
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">选手列表</span>
        </el-col>
        <el-col :span="15" style="text-align: right;">
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="姓名" prop="userName"></el-table-column>
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column label="学校" prop="schoolName"></el-table-column>
        <el-table-column label="年级" prop="grade" :formatter="gradeFormatter"></el-table-column>
        <el-table-column label="比赛号码牌" prop="matchNum">
          <template slot-scope="scope">
            <span class="num">{{ addZero(scope.row.matchNum) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- 查看详情 -->
    <el-dialog
      title="作答详情"
      :visible.sync="dialogVisible"
      width="900px">
      <el-row>
        <el-col :span="6"><div class="total">姓名：<span>{{ userName }}</span></div></el-col>
        <el-col :span="6"><div class="total">比赛号码牌：<span>{{ matchNum }}</span></div></el-col>
        <el-col :span="6"><div class="total">电话：<span>{{ phone }}</span></div></el-col>
        <el-col :span="6"><div class="total">总分：<span>{{ totalScore }}</span></div></el-col>
      </el-row>
        <el-table header-cell-class-name="tableHeaderStyle" :data="paperData" stripe border>
          <el-table-column prop="quizNumber" label="题号" width="80px">
            <template slot-scope="scope">
              {{ scope.row.quizNumber }}
              <span v-if="scope.row.isStandby === 1">(备用)</span>
            </template>
          </el-table-column>
          <el-table-column prop="typeName" label="题型"></el-table-column>
          <el-table-column label="正确答案" prop="correctAnswerList">
            <template slot-scope="scope">
              <div class="font-flex">
                <div class="font-box" v-for="(font, fi) of scope.row.correctAnswerList" :key="font">
                  <img class="answer-img" v-if="font.length > 5" :key="fi" :src="font" alt="">
                  <span class="font" v-else>{{ font }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="用户答案" prop="answerList">
            <template slot-scope="scope">
              <div class="font-flex" v-if="scope.row.answerList.length">
                <div class="font-box" v-for="(font, fi) of scope.row.answerList" :key="font">
                  <img class="answer-img" v-if="font.length > 5" :key="fi" :src="font" alt="">
                  <span class="font" v-else>{{ font }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="score" label="得分">
            <template slot-scope="scope">
              <el-input v-model="scope.row.score" type="number" @blur="saveScore(scope.row)" style="width: 120px;"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="判定">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.score !== undefined"
                :type="scope.row.score === 0 || scope.row.score === '0' ? 'danger' : 'success'"
                size="mini">
                {{scope.row.score === 0 || scope.row.score === '0' ? '错误' : '正确'}}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      <!-- </div> -->
    </el-dialog>
    <!-- 设置本轮晋级弹窗 -->
    <el-dialog
        title="设置晋级"
        :visible.sync="roundPromotionDialogVisible"
        width="30%"
        @close="handleCloseRoundPromotionDialog"
    >
        <el-form
            :model="roundPromotionForm"
            label-width="100px"
            ref="roundPromotionFormRef"
            :rules="roundPromotionFormRules"
        >
            <el-form-item label="姓名" prop="examinationUserName">
                <el-input
                    v-model="roundPromotionForm.examinationUserName"
                    placeholder="请输入"
                    disabled
                ></el-input>
            </el-form-item>
            <el-form-item label="晋级状态" prop="promotion">
                <el-select v-model="roundPromotionForm.promotion" placeholder="请选择晋级状态" style="width: 100%">
                    <el-option label="未设置" :value="0"></el-option>
                    <el-option label="晋级" :value="1"></el-option>
                    <el-option label="未晋级" :value="2"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="roundPromotionDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmFn">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 批量设置晋级 -->
    <el-dialog
        title="批量设置晋级"
        :visible.sync="visible"
        width="560px"
        @close="handleCloseDialogSet"
    >
        <div style="text-align: left" v-if="activeRoundName === '1'">
            <span style="margin-right: 12px; margin-left: 28px">设置成绩为</span>
            <el-input-number v-model="score" :min="0" style="text-align: left"></el-input-number>
            <span style="margin-left: 12px">分及以上的选手晋级</span>
        </div>
        <div style="text-align: left" v-if="activeRoundName === '2'">
            <span style="margin-right: 12px; margin-left: 28px">设置前</span>
            <el-input-number v-model="promotionNum" :min="0" style="text-align: left"></el-input-number>
            <span style="margin-left: 12px">位选手晋级</span>
        </div>
        <div style="text-align: center; margin-top: 40px">
            <el-button type="primary" @click="settingFn"
                >确认设置</el-button
            >
        </div>
    </el-dialog>
  </div>
</template>
<script>
import { setTbEnrollmentRoundPromotion } from '@/http/api'

export default {
  data () {
    return {
      dict_season: [],
      dict_grade: this.$userInfo.getGradeData(),
      dict_group: this.$userInfo.dict_group(),
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason,
        phone: '',
        userName: '',
        isGroup: 1,
        level: '1'
      },
      isGroup: 1,
      pageIndex: 1,
      pageSize: 20,
      pageIndex2: 1,
      pageSize2: 20,
      total2: 0,
      scoreValid: false,
      total: 0,
      dataList: [],
      dateRange: [],
      dialogVisible: false,
      paperData: [],
      totalScore: 0,
      userName: '',
      matchNum: '',
      phone: '',
      activeName: 'first',
      nationalId: '',
      nationalGroupId: '',
      activeRoundName: '1',
      dataFinalList: [],
      dataListFinalMixedGroup: [],
      roundPromotionDialogVisible: false,
      roundPromotionForm: {
        id: '',
        examinationUserName: '',
        promotion: null
      },
      revivalForm: {},
      roundPromotionFormRules: {
        promotion: [{ required: true, message: '请选择晋级状态', trigger: 'change' }]
      },
      visible: false,
      score: 0,
      promotionNum: 10,
      url: '',
      params: {}
    }
  },
  created () {
    const level = this.$route.query.level
    if (level) {
      this.activeRoundName = this.$route.query.round
      this.queryForm.season = this.$route.query.season
      this.queryForm.level = level
    }
    this.getSeason()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getSeason () {
      this.$userInfo.getDataList(this, 't_season').then(value => {
        this.dict_season = value
        // this.queryForm.season = value[0].dictValue
        // this.getDataList()
        this.searchFn()
      })
    },
    searchFn () {
      console.log(this.queryForm)
      if (this.activeName === 'first') {
        if (this.queryForm.season === '2024~2025') {
          this.pageIndex2 = 1
          this.getSeason3GroupList()
        } else {
          this.pageIndex = 1
          this.isGroup = 1
          this.getDataList()
        }
      } else {
        this.queryForm.level = ''
        this.isGroup = 2

        if (this.queryForm.season === '2024~2025') {
          this.pageIndex3 = 1
          this.getSeason3MixedGroupList()
        } else {
          this.pageIndex = 1
          this.getDataList()
        }
      }
    },
    getSeason3GroupList () {
      // 根据轮次选择不同的接口
      if (this.activeRoundName === '1') {
        // 第一轮使用原接口
        this.$http.get('national/queryNationalOneRoundListPage', {
          params: { ...{ scoreValid: this.scoreValid, pageNum: this.pageIndex2, pageSize: this.pageSize2 }, ...this.queryForm }
        }).then(res => {
          this.dataFinalList = res.data.list
          this.total2 = res.data.total
        })
      } else if (this.activeRoundName === '2' || this.activeRoundName === '3') {
        // 第二轮和第三轮使用新接口
        const obj = this.activeRoundName === '2' ? { scoreValid: this.scoreValid } : {}
        this.$http.get('national/queryUsersByRound', {
          params: { ...{ ...obj, pageNum: this.pageIndex2, pageSize: this.pageSize2, phase: this.activeRoundName }, ...this.queryForm }
        }).then(res => {
          if (res.code === 200) {
            this.dataFinalList = res.data.list
            this.total2 = res.data.total
          }
        })
      } else if (this.activeRoundName === '4') { // 复活赛
        this.$http.get('nationalResurrectionSign/signList', {
          params: { ...{ scoreValid: this.scoreValid, pageNum: this.pageIndex2, pageSize: this.pageSize2 }, ...this.queryForm }
        }).then(res => {
          this.dataFinalList = res.data.list
          this.total2 = res.data.total
        })
      }
    },
    getSeason3MixedGroupList () {
      this.$http.get('national/queryNationalGroupList', {
        params: {
          activityType: this.queryForm.activityType,
          season: this.queryForm.season,
          raceSchedule: '4',
          isGroup: this.isGroup,
          round: 1
        }
      }).then(res => {
        this.dataListFinalMixedGroup = res.data
      })
    },
    handleSizeChange2 (e) {
      this.pageSize2 = e
      this.getSeason3GroupList()
    },
    handleCurrentChange2 (e) {
      this.pageIndex2 = e
      this.getSeason3GroupList()
    },
    getDataList () {
      this.$http.get('national/queryNationalAnswerList', { params: { ...this.queryForm, ...{ pageNum: this.pageIndex, pageSize: this.pageSize, isGroup: this.isGroup } } }).then(res => {
        if (res.code === 200) {
          this.dataList = res.data.list
          this.total = res.data.total
        }
      })
    },
    refreshDataList () {
      this.pageIndex2 = 1
      this.getSeason3GroupList()
    },
    addZero (num) {
      return this.$xcUtils.addZero(num)
    },
    search () {
      this.pageIndex = 1
      this.getDataList()
    },
    reset () {
      this.$refs.queryFormRef.resetFields()
      // this.queryForm.season = this.dict_season[0].dictValue
      this.searchFn()
    },
    handleSizeChange (e) {
      this.pageSize = e
      this.getDataList()
    },
    handleCurrentChange (e) {
      this.pageIndex = e
      this.getDataList()
    },
    gradeFormatter (data) {
      return this.dict_grade.find(gr => gr.dictCode === data.grade).dictLabel
    },
    levelFormat (row) {
      const level = row.level
      return level ? this.dict_group.find(item => Number(item.dictValue) === level).dictLabel : '-'
    },
    scoreRoundEditDialog (row) {
      if (row.tbEnrollmentRoundInfos && row.tbEnrollmentRoundInfos.length > 0) {
        this.roundPromotionForm.id = row.tbEnrollmentRoundInfos[0].id
      } else {
        this.roundPromotionForm.id = ''
      }
      // 号码牌
      const number = this.activeRoundName === '1' || this.activeRoundName === '3' ? row.matchNum : this.activeRoundName === '2' ? row.tbEnrollmentRoundInfos[0].number : ''
      this.roundPromotionForm.examinationUserName = row.userName
      this.roundPromotionForm.promotion = this.getCurrentRoundPromotion(row)
      this.roundPromotionForm.phase = this.activeRoundName
      this.roundPromotionForm.userId = row.userId
      this.roundPromotionForm.raceScheduleType = '4'
      this.roundPromotionForm.season = this.queryForm.season
      this.roundPromotionForm.enrollmentId = row.enrollmentId
      this.roundPromotionForm.number = number
      this.roundPromotionForm.level = row.level
      this.roundPromotionForm.isGroup = this.isGroup
      this.roundPromotionDialogVisible = true
    },
    scoreRoundEditDialog2 (row) {
      this.revivalForm.id = row.id
      this.roundPromotionForm.examinationUserName = row.userName
      this.roundPromotionForm.promotion = row.promotion
      this.roundPromotionDialogVisible = true
    },
    confirmFn () {
      if (this.activeRoundName === '4') {
        this.setRevival()
      } else {
        this.saveRoundPromotionData()
      }
    },
    // 保存本轮晋级数据
    saveRoundPromotionData () {
      this.$refs.roundPromotionFormRef.validate(async valid => {
        if (!valid) return false
        setTbEnrollmentRoundPromotion(this.roundPromotionForm).then(res => {
          this.$message.success('设置成功')
          this.roundPromotionDialogVisible = false
          this.searchFn()
        }).catch(err => {
          console.log('设置失败', err)
          // this.$message.error('设置失败')
        })
      })
    },
    // 复活赛晋级
    setRevival () {
      this.$refs.roundPromotionFormRef.validate(async valid => {
        if (!valid) return false
        this.$http.get('nationalResurrectionSign/updatePromotion', {
          params: {
            id: this.revivalForm.id,
            promotion: this.roundPromotionForm.promotion
          }
        }).then(res => {
          this.$message.success('设置成功')
          this.roundPromotionDialogVisible = false
          this.searchFn()
        }).catch(err => {
          console.log('设置失败', err)
          // this.$message.error('设置失败')
        })
      })
    },
    turnAnswerResult (rowData) {
      // if (this.activeRound === '1') {
      console.log('rowData', rowData)
      if (!rowData.formQuizMatchResultId && this.activeRoundName === '1') {
        this.$message.warning('暂无答题详情')
        return
      }
      // var formData = {
      //   season: this.$chnEngStatusCode.defaultSeason,
      //   activityType: this.$chnEngStatusCode.activityType,
      //   raceSchedule: this.queryForm.raceSchedule,
      //   userId: rowData.userId
      // }
      var formData2 = {
        matchResultId: rowData.formQuizMatchResultId || '',
        season: this.$chnEngStatusCode.defaultSeason,
        userName: rowData.userName,
        score: rowData.roundOne || rowData.score,
        activeRound: this.activeRoundName,
        phase: this.activeRoundName,
        raceSchedule: '4',
        userId: rowData.userId,
        // id: this.queryForm.examinationId
        isNational: 1,
        level: rowData.level,
        isGroup: this.isGroup
      }
      console.log(formData2)
      this.$router.push(
        {
          path: '/schedule_Childview/individual_answer_result',
          query: {
            formDataStr: JSON.stringify(formData2)
          }
        }
      )
      // } else if (this.activeRound === '2' || this.activeRound === '3') {
      //   var formData3 = {
      //     matchResultId: rowData.formGroupMatchResultId,
      //     season: this.$chnEngStatusCode.defaultSeason,
      //     userName: rowData.examinationUserName,
      //     score: rowData.score,
      //     activeRound: this.activeRound,
      //     phase: this.queryForm.phase,
      //     raceSchedule: this.queryForm.raceSchedule,
      //     userId: rowData.userId,
      //     id: this.queryForm.examinationId
      //   }
      //   this.$router.push(
      //     {
      //       path: '/schedule_Childview/individual_answer_result',
      //       query: {
      //         formDataStr: JSON.stringify(formData3)
      //       }
      //     }
      //   )
      // }
    },
    // 关闭设置本轮晋级弹窗
    handleCloseRoundPromotionDialog () {
      this.$refs.roundPromotionFormRef.resetFields()
      this.roundPromotionForm = {
        id: '',
        examinationUserName: '',
        promotion: null
      }
    },
    settingFn () {
      this.$confirm('确认设置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.activeRoundName === '1') {
          this.url = 'national/setPromotionBatch'
          this.params = {
            season: this.queryForm.season,
            level: this.queryForm.level,
            score: this.score,
            activityType: this.queryForm.activityType,
            isGroup: this.queryForm.isGroup
          }
        } else if (this.activeRoundName === '2') {
          this.url = 'national/setPromotionBatchRoundTwo'
          this.params = {
            season: this.queryForm.season,
            level: this.queryForm.level,
            promotionNum: this.promotionNum,
            phase: this.activeRoundName,
            endState: false,
            activityType: this.queryForm.activityType,
            isGroup: this.queryForm.isGroup
          }
        }
        this.$http.post(this.url, this.params).then(res => {
          if (res.code === 200) {
            this.visible = false
            this.$message.success('设置晋级成功')
            this.searchFn()
          }
        })
      }).catch(() => {
        // 用户取消操作
      })
    },
    handleCloseDialogSet () {
      this.visible = false
    },
    handleToReferee () {
      this.$router.push(`/academic_Management/refereeFinalManagement?group=1&season=${this.queryForm.season}&level=${this.queryForm.level}&round=${this.activeRoundName}`)
    },
    exportFn () {
      const url = this.activeRoundName === '1' ? 'national/exportNationalOneRoundListPage' : 'national/exportUsersByRound'
      const params1 = { ...{ scoreValid: this.scoreValid, pageNum: this.pageIndex2, pageSize: this.pageSize2 }, ...this.queryForm }
      const params2 = { ...{ scoreValid: this.scoreValid, pageNum: this.pageIndex2, pageSize: this.pageSize2, phase: this.activeRoundName }, ...this.queryForm }
      const paramsData = this.activeRoundName === '1' ? params1 : params2
      this.$downLoadFile.downLoadFileWithUrlNew(this, (this.$env.baseIP + url), paramsData)
    },
    showDetail (data) {
      this.userName = data.userName
      this.phone = data.phone
      this.matchNum = this.addZero(data.matchNum)
      this.userId = data.userId

      const params = {
        activityType: this.queryForm.activityType,
        season: this.queryForm.season,
        isGroup: this.isGroup,
        nationalId: data.nationalId,
        userId: data.userId,
        level: this.isGroup === 1 ? data.level : ''
      }
      this.$http.get('/national/queryNationalAnswerInfo', { params }).then(res => {
        if (res.code === 200) {
          if (res.data.answerInfos && res.data.answerInfos.length) {
            this.dialogVisible = true
            this.totalScore = res.data.roundOne
            this.nationalGroupId = res.data.nationalGroupId
            this.nationalId = res.data.nationalId
            res.data.answerInfos.forEach(item => {
              item.answerList = item.answer ? item.answer.split(',') : []
              item.correctAnswerList = item.correctAnswer.split(',')
            })
            this.paperData = res.data.answerInfos
          } else {
            this.$message.warning('暂无答题记录')
          }
        }
      })
    },
    // 获取当前轮次的晋级状态
    getCurrentRoundPromotion (row) {
      if (row.tbEnrollmentRoundInfos && row.tbEnrollmentRoundInfos.length > 0) {
        // 根据当前选中的轮次查找对应的晋级信息
        const currentRoundInfo = row.tbEnrollmentRoundInfos[0]
        console.log('currentRoundInfo', currentRoundInfo)
        return currentRoundInfo ? currentRoundInfo.promotion : null
      }
      return null
    },
    saveScore (item) {
      this.$http.post('/national/saveErpNationalAnswer', {
        activityType: this.queryForm.activityType,
        answer: '',
        isGroup: this.isGroup,
        nationalFormId: item.nationalFormId,
        nationalFormInfoId: item.nationalFormInfoId,
        nationalGroupId: this.nationalGroupId,
        nationalId: this.nationalId,
        score: Number(item.score),
        season: this.queryForm.season,
        userId: this.userId
      }).then(res => {
        if (res.code === 200) {

        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  .h1{
    color: #000;
    margin-top: 20px;
  }
  .h2{
    color: #000;
  }
  .total{
    font-size: 16px;
    color: #000;
    span{
      color: #409EFF;
    }
  }
  .font-flex{
    display: flex;
    align-items: center;
  }
  .font-box{
    border: 1px solid #409EFF;
    border-radius: 4px;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    margin: 4px;
  }
  .font{
    color: #000;
    font-size: 16px;
  }

  .answer-img{
    height: 26px;
    border-radius: 6px;
    margin-top: 1px;
  }
  .tab-search-card{
    background-color: #fff;
    padding: 20px;
  }
  /deep/ .el-tabs--border-card{
    border: none;
    box-shadow: none;
  }
  /deep/ .el-tabs__content{
    padding: 0;
  }
  .num {
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.tips{
  font-size: 14px;
  color: #333;
  line-height: 40px;
}
</style>
